/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/AnswerBean', 'model/DefinitionBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./AnswerBean'), require('./DefinitionBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.FormResponseBean = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.AnswerBean, root.BpmbuildUatDsappspotcom.DefinitionBean);
  }
}(this, function(ApiClient, AnswerBean, DefinitionBean) {
  'use strict';

  /**
   * The FormResponseBean model module.
   * @module model/FormResponseBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>FormResponseBean</code>.
   * @alias module:model/FormResponseBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>FormResponseBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FormResponseBean} obj Optional instance to populate.
   * @return {module:model/FormResponseBean} The populated <code>FormResponseBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('answers'))
        obj.answers = ApiClient.convertToType(data['answers'], [AnswerBean]);
      if (data.hasOwnProperty('calculated'))
        obj.calculated = ApiClient.convertToType(data['calculated'], 'String');
      if (data.hasOwnProperty('definition'))
        obj.definition = DefinitionBean.constructFromObject(data['definition']);
      if (data.hasOwnProperty('form_id'))
        obj.formId = ApiClient.convertToType(data['form_id'], 'String');
      if (data.hasOwnProperty('landed_at'))
        obj.landedAt = ApiClient.convertToType(data['landed_at'], 'String');
      if (data.hasOwnProperty('submitted_at'))
        obj.submittedAt = ApiClient.convertToType(data['submitted_at'], 'String');
      if (data.hasOwnProperty('token'))
        obj.token = ApiClient.convertToType(data['token'], 'String');
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/AnswerBean>} answers
   */
  exports.prototype.answers = undefined;

  /**
   * @member {String} calculated
   */
  exports.prototype.calculated = undefined;

  /**
   * @member {module:model/DefinitionBean} definition
   */
  exports.prototype.definition = undefined;

  /**
   * @member {String} formId
   */
  exports.prototype.formId = undefined;

  /**
   * @member {String} landedAt
   */
  exports.prototype.landedAt = undefined;

  /**
   * @member {String} submittedAt
   */
  exports.prototype.submittedAt = undefined;

  /**
   * @member {String} token
   */
  exports.prototype.token = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/FormResponseBean.js